import { doc } from "firebase/firestore";
import { firestore } from "../firebase";
import { chatPaths } from "./chatsPath";

const getChatRef = (selectedChatSnapId) => {
  return doc(firestore, `${chatPaths.chatCollection}/${selectedChatSnapId}`)
};

export default getChatRef;